import { render } from "./noteBox.vue?vue&type=template&id=48660733"
import script from "./noteBox.vue?vue&type=script&lang=js"
export * from "./noteBox.vue?vue&type=script&lang=js"

import "./noteBox.vue?vue&type=style&index=0&id=48660733&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__